import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addFaqAnswer, addFaqQuestion, onchangeAdditionFaqContext } from '../../features/appSlice';
import ModalSignup from '../../ui/modal/modalSignup';
import faqclasses from './YourFaqs.module.css';
const YourFaqs = (props) => {
	const dispatch = useDispatch();
	const [showFaqModal, setshowFaqModal] = useState(false);
	const [modalBody, setmodalBody] = useState('');
	const [modalFooter, setmodalFooter] = useState('');
	const [modaltitle, setModalTitle] = useState('');
	const [modalLoader, setmodalLoader] = useState(false);
	const faqInputRef = useRef();
	const state = useSelector((state) => state);
	const faqdata = state?.app?.contextData?.your_faq;

	const openModalAdd = () => {
		setshowFaqModal(true);
		setmodalBody(modalBodyFaq());
		setmodalFooter(modalFooterFaq());
		setModalTitle('Add additional faq question');
	}

	const closeModalAdd = () => {
		setshowFaqModal(false);
		setmodalBody('');
		setmodalFooter('');
		setModalTitle('');
	}




	const onchangefaq = (e, i) => {
		dispatch(addFaqAnswer([e.target.value, i]));
	}



	useEffect(() => {
	}, [props.results]);


	const saveFaqQuestion = () => {
		const va = faqInputRef.current.value;
		closeModalAdd();
		dispatch(addFaqQuestion(va));
	}
	const handleAdditionalContext = (e) => {
		dispatch(onchangeAdditionFaqContext(e.target.value));
	}

	const modalFooterFaq = () => {
		return (
			<>
				<button
					type="button"
					className="yr-cancelbtn"
					data-dismiss="modal"
					onClick={closeModalAdd}
				>
					<span>No</span>

				</button>
				<button
					type="button"
					className="btn linear-gradient zy-save-btn width-100"
					onClick={saveFaqQuestion}
				>
					Yes
				</button>
			</>
		)
	}

	const modalBodyFaq = () => {
		return (
			<>
				<div className='row'>
					<div className='form-group'>
						<label>Question</label>
						<input
							type="text"
							name='faqAdditionalQuestion'
							className='form-control'
							ref={faqInputRef}
						/>
					</div>
				</div>

			</>
		)
	}

	return (
		<div className={`tab-pane fade ${(props.activeTab === 4) && 'show active'}`} id="yourfaq" role="tabpanel" aria-labelledby="yourfaq-tab">
			<div className='col-md-12'>
				<div className='row'>
					<h2 className='box-title'>FAQs</h2>
					{faqdata?.map((item, i) => {
						return (
							<div className={`${faqclasses.FAQ_section}`} key={i.toString()}>
								<span>{item?.q}</span>

								<textarea
									className={`form-control ${faqclasses.inputTextare}`}
									value={item.a}
									onChange={(event) => onchangefaq(event, i)}
								>
								</textarea>

							</div>
						)
					})}

					<div className="addNewFAQ mb-4">
						<a className={`${faqclasses.addLink}`} onClick={() => openModalAdd()} style={{ textDecoration: 'none' }} >
							+ Add an addition FAQ
						</a>
					</div>
					<div className='col-md-12'>

						<div className='form-group'>
							<label style={{ fontWeight: 600 }}>Addition Faqs Context </label>
							<textarea
								className='form-control'
								rows={5}
								value={state.app.contextData.additonal_faq_context == "null" ? '' : state.app.contextData.additonal_faq_context}
								onChange={(e) => handleAdditionalContext(e)}
							></textarea>

						</div>
					</div>
				</div>
			</div>
			<ModalSignup
				show={showFaqModal}
				modalFooter={modalFooter}
				modalBody={modalBody}
				title={modaltitle}
				closeModal={closeModalAdd}
				modalLoader={modalLoader}
			/>
		</div>
	)
}

export default YourFaqs